import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("生成")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_dropdown_menu, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_dropdown_item, {
          modelValue: _ctx.valueBookShop,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueBookShop) = $event)),
          options: _ctx.optionBookShop
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      modelValue: _ctx.cardNumber,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardNumber) = $event)),
      autosize: "",
      placeholder: "请输入生成数量"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_button, {
      type: "primary",
      onClick: _ctx.createNumber
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}